var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 41,
    viewBox: "0 0 140 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5A623",
    d: "M70 33.75L56.775 40.703 59.301 25.976 48.601 15.547 63.387 13.399 70 0 76.613 13.399 91.399 15.547 80.699 25.976 83.225 40.703z",
    opacity: 0.146,
    transform: "translate(-192 -399) translate(105 37) translate(51 324) translate(36 38)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M70 7.5l3.5 8.5",
    opacity: 0.569,
    transform: "translate(-192 -399) translate(105 37) translate(51 324) translate(36 38)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A623",
    d: "M109.25 29.75L100.727 34.231 102.355 24.74 95.46 18.019 104.989 16.635 109.25 8 113.511 16.635 123.04 18.019 116.145 24.74 117.773 34.231zM30.75 29.75L22.227 34.231 23.855 24.74 16.96 18.019 26.489 16.635 30.75 8 35.011 16.635 44.54 18.019 37.645 24.74 39.273 34.231zM7 26.5L2.886 28.663 3.671 24.082.343 20.837 4.943 20.168 7 16 9.057 20.168 13.657 20.837 10.329 24.082 11.114 28.663zM133 26.5L128.886 28.663 129.671 24.082 126.343 20.837 130.943 20.168 133 16 135.057 20.168 139.657 20.837 136.329 24.082 137.114 28.663z",
    opacity: 0.146,
    transform: "translate(-192 -399) translate(105 37) translate(51 324) translate(36 38)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStars);
export default __webpack_public_path__ + "static/media/img-stars.66ede34baff969722325d945bc21cfe6.svg";
export { ForwardRef as ReactComponent };